var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnselectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 0.0) scale(0.857143)"
  }, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 0.5,
    y: 0.5,
    rx: 13.5,
    width: 27,
    height: 27,
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.75,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedIcon);
export default __webpack_public_path__ + "static/media/unselectedIcon.906be84bd9fde622114ebec2b7fb14af.svg";
export { ForwardRef as ReactComponent };